import styled from 'styled-components'

import { _M_Medium, _S_Normal, _XS_Medium, mainColors, medias } from '../../styles'
import { GroupTheme } from './_types'

export const Container = styled.div<{ rectangular: boolean }>`
  position: relative;
  height: ${p => (p.rectangular ? 30 : 24)}px;
  display: flex;
  flex: 1;
  justify-content: center;
`

interface IControlProps {
  disabled?: boolean
  checked?: boolean
}

export const ControlDefault = styled.label<
  IControlProps & {
    rectangular: boolean
  }
>`
  display: flex;
  align-items: center;
  height: ${p => (p.rectangular ? 30 : 24)}px;
  width: max-content;
  background: ${mainColors.neutralExtraLight};
  border-radius: ${p => (p.rectangular ? 2 : 20)}px;
  padding: 0 10px !important;
  cursor: pointer;

  ${props =>
    props.disabled &&
    `
    cursor: not-allowed;
    ${Title} {
      color: ${mainColors.neutralExtraDark};
    }
  `}
`

export const HiddenControlInput = styled.input<IControlProps>`
  display: none;
  cursor: pointer;
  position: absolute;

  &:hover + label {
    background: ${mainColors.neutralMedium};
  }

  &:checked + label {
    background: ${mainColors.accentMedium};

    span {
      color: ${mainColors.white};
    }
  }
`

export const ControlChildren = styled.span<{ noMargin: boolean }>`
  margin-left: ${p => (p.noMargin ? 0 : 7)}px;
  display: flex;
  align-items: center;
  color: ${mainColors.neutralDark};
`

export const Title = styled.span`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark};
`

export const GroupTitle = styled.label`
  display: none;
  ${_XS_Medium};
  margin-right: 12px;
  color: ${mainColors.neutralExtraDark};

  ${medias.LG_SCREEN`
    display: block;
  `}
`

export const GroupContainer = styled.div<{ $rectangular: boolean; $fullWidth: boolean }>`
  background: ${mainColors.neutralExtraLight};
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: ${({ $rectangular }) => ($rectangular ? 4 : 60)}px;
  padding: 3px;
  display: flex;
  align-items: center;

  ${({ $fullWidth }) => ($fullWidth ? 'flex: 1' : undefined)};

  ${Container}:not(:last-child) {
    margin-right: 4px;
  }

  ${Container}:not(:first-child) {
    margin-left: 4px;
  }
`

export const Root = styled.div<{ $theme?: GroupTheme }>`
  display: flex;
  align-items: center;

  ${({ $theme }) =>
    $theme === GroupTheme.button &&
    `
    gap: 6px;
    width: 100%;
    min-height: 36px;

    ${GroupTitle} {
      min-width: max-content;
    }

    ${GroupContainer} {
      background: none;
      border: none;
      width: 100%;
      gap: 6px;
    }

    ${Container} {
      min-height: 36px;
      width: 100%;
    }

    ${HiddenControlInput} {
      &:hover + label {
        background-color: ${mainColors.neutralMedium};
      }

      &:checked + label {
        background-color: ${mainColors.accentMedium};
        border: none;

        span {
          color: ${mainColors.white};
        }
      }
    }

    ${ControlButtonWrapper} {
      width: 100%;
    }

    ${ControlDefault} {
      border-radius: 4px;
      min-height: 36px;
      min-width: 100%;
      width: 100%;
      border: 1px solid ${mainColors.neutralMedium};
    }

    ${Title} {
      text-align: center;
      width: 100%;
      ${_M_Medium};
    }
  `}
`

export const ControlButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`
